<template>
  <v-container fluid class="pa-0 ma-0">
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="295"
      fixed-header
      must-sort
      dense
      disable-pagination
      hide-default-footer
      class="tableSelectCursor"
    >
      <template v-slot:[`header.name`]="{ header }">
        <v-btn icon @click="dialogListPlanned = true">
          <v-icon>{{ mdiViewList }}</v-icon>
        </v-btn>
        {{ header.text }}
      </template>
      <template v-slot:item="{ item }">
        <tr @click="((dialogDetail = true), (visitor = item))">
          <td>
            {{ item.name }}
            <br />
            {{ item.surname }}
          </td>
          <td class="pl-1">
            {{ item.employee.name }}
            <br />
            {{ item.employee.surname }}
          </td>
          <td class="pl-1">
            <b>{{ formatDate(item.timeArrive, $store.state.auth.df.time) }}</b>
            <br />
            {{ formatDate(item.timeArrive, $store.state.auth.df.date) }}
          </td>
          <td class="pa-0 ma-0">
            <v-icon v-if="item.car.plate !== ''">{{ mdiCar }}</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!--------------------DIALOGS----------------------------------------------->
    <v-dialog v-model="dialogDetail" width="60%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('head.plannedVisit') }}
          <v-spacer />
          <v-icon large @click="dialogDetail = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row>
            <v-col cols="3">
              <h4>{{ $tc('label.visitor') }}:</h4>
            </v-col>
            <v-col cols="9">
              <h3>{{ visitor.name }} {{ visitor.surname }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.document') }}:</h4>
            </v-col>
            <v-col cols="3">
              <h3>{{ getDocumentType(visitor.documenttype) }}</h3>
            </v-col>
            <v-col cols="3">
              <h3>{{ visitor.documentno }}</h3>
            </v-col>
            <v-col cols="3">
              <h3>{{ getCountryName(visitor.country) }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $tc('label.company') }}:</h4>
            </v-col>
            <v-col cols="3">
              <h3>{{ visitor.company.name }}</h3>
            </v-col>
            <v-col cols="3">
              <h4>{{ $tc('label.car') }}:</h4>
            </v-col>
            <v-col cols="3">
              <h3>{{ visitor.car.plate }} - {{ visitor.car.type }} {{ visitor.car.color }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.arrival') }}:</h4>
            </v-col>
            <v-col cols="3">
              <h3 v-if="visitor.timeArrive" class="green--text">{{ formatDate(visitor.timeArrive, $store.state.auth.df.time) }}</h3>
            </v-col>
            <v-col cols="3">
              <h4>{{ $t('label.departure') }}:</h4>
            </v-col>
            <v-col cols="3">
              <h3 v-if="visitor.timeDeparture" class="green--text">{{ formatDate(visitor.timeDeparture, $store.state.auth.df.time) }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.visiting') }}:</h4>
            </v-col>
            <v-col cols="9">
              <h3>{{ visitor.employee.name }} {{ visitor.employee.surname }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" v-if="visitor.employee.email">
              <h4>{{ $t('label.email') }}:</h4>
            </v-col>
            <v-col cols="3" v-if="visitor.employee.email">
              <h3>{{ visitor.employee.email }}</h3>
            </v-col>
            <v-col cols="3" v-if="visitor.employee.phone">
              <h4>{{ $t('label.phone') }}:</h4>
            </v-col>
            <v-col cols="3" v-if="visitor.employee.phone">
              <h3>{{ visitor.employee.phone }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.visitorNote') }}:</h4>
            </v-col>
            <v-col cols="9">
              <h3>{{ visitor.note }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.approvedBy') }}:</h4>
            </v-col>
            <v-col cols="9">
              <h3>{{ visitor.approverName }} {{ visitor.approverSurname }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" v-if="visitor.approverEmail">
              <h4>{{ $t('label.email') }}:</h4>
            </v-col>
            <v-col cols="3" v-if="visitor.approverEmail">
              <h3>{{ visitor.approverEmail }}</h3>
            </v-col>
            <v-col cols="3" v-if="visitor.approverPhone">
              <h4>{{ $t('label.phone') }}:</h4>
            </v-col>
            <v-col cols="3" v-if="visitor.approverPhone">
              <h3>{{ visitor.approverPhone }}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <h4>{{ $t('label.approvalNote') }}:</h4>
            </v-col>
            <v-col cols="9">
              <h3>{{ visitor.approvalNote }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-col cols="12"
            ><v-btn block color="colorSave" @click="setDataToInput">{{ $t('btn.submit') }}</v-btn></v-col
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogListPlanned" width="80%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('head.plannedVisitsList') }}
          <v-spacer />
          <v-icon large @click="dialogListPlanned = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="px-2 pt-0">
          <v-text-field
            v-model="search"
            background-color="colorSearchSettings"
            clearable
            :append-icon="mdiMagnify"
            :label="$t('label.search') + ':'"
            hide-details
          ></v-text-field>
          <v-data-table
            :search="search"
            :headers="headersDetail"
            :items="tableData"
            :height="400"
            fixed-header
            must-sort
            dense
            disable-pagination
            hide-default-footer
            class="tableCursor"
          >
            <template v-slot:item="{ item }">
              <tr @click="((dialogDetail = true), (visitor = item))">
                <td class="px-1">{{ item.name }}</td>
                <td class="px-1">{{ item.surname }}</td>
                <td class="px-1">{{ item.employee.name }} {{ item.employee.surname }}</td>
                <td class="px-1">{{ formatDate(item.timeArrive, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-1">{{ formatDate(item.timeDeparture, $store.state.auth.df.dateYearTime) }}</td>
                <td class="px-1">{{ item.approverName }} {{ item.approverSurname }}</td>
                <td class="px-1">{{ item.car.plate }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import { mdiViewList, mdiMagnify, mdiClose, mdiCar } from '@mdi/js';

export default Vue.extend({
  name: 'worklplaceWidgetPlannedVisits',
  props: {
    countries: Array,
    documentTypes: Array,
    searchPlannedVisit: Object,
    openPlanned: Boolean,
  },
  data: () => ({
    search: '',
    tableData: [] as any,
    visitor: {
      id: 0,
      name: '',
      surname: '',
      documentno: '',
      country: '',
      documenttype: '',
      note: '',
      approverName: '',
      approverSurname: '',
      approverEmail: '',
      approverPhone: '',
      approvalNote: '',
      timeArrive: '',
      timeDeparture: '',
      tranFrom: '',
      company: {
        id: 0,
        name: '',
      },
      car: {
        id: 0,
        plate: '',
        color: '',
        type: '',
      },
      expire: '',
      employee: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        phone: '',
      },
      plannedVisitID: 0,
    },
    dialogDetail: false,
    dialogListPlanned: false,
    mdiViewList: mdiViewList,
    mdiMagnify: mdiMagnify,
    mdiClose: mdiClose,
    mdiCar: mdiCar,
  }),
  computed: {
    headers() {
      return [
        { text: this.$t('label.name'), value: 'name', sortable: false, width: '30%' },
        { text: this.$t('label.visiting'), sortable: false, width: '30%' },
        { text: this.$t('label.arrival'), sortable: false, width: '30%' },
        { text: '', sortable: false, width: '5%' },
      ];
    },
    headersDetail() {
      return [
        { text: this.$t('label.name'), value: 'name' },
        { text: this.$t('label.surname'), value: 'surname' },
        { text: this.$t('label.visiting'), value: 'employeeFullName' },
        { text: this.$t('label.arrival'), value: 'timeArrive' },
        { text: this.$t('label.departure'), value: 'timeDeparture' },
        { text: this.$t('label.approvedBy'), value: 'approverFullName' },
        { text: this.$tc('label.car', 1), value: 'car' },
      ];
    },
  },
  watch: {
    openPlanned() {
      // Reaguj len ak je zoznam dlhsi ako 0 a akce je "true"
      this.tableData.length > 0 && this.openPlanned ? (this.dialogListPlanned = this.openPlanned) : null;
      this.openPlanned ? this.$emit('update:openPlanned', false) : null;
    },
    '$store.state.websocket.flushPlannedVisits'() {
      this.$store.state.websocket.flushPlannedVisits ? this.dataLoad() : null;
      this.$store.commit('flushPlannedVisits', false);
    },
    searchPlannedVisit() {
      this.dialogDetail = false;
      if (this.searchPlannedVisit.tranFrom === 'reader') {
        for (const row of this.tableData) {
          if (
            this.searchPlannedVisit.documentno === row.documentno.toUpperCase() &&
            this.searchPlannedVisit.documenttype === row.documenttype &&
            this.searchPlannedVisit.country === row.country
          ) {
            this.visitor = { ...row };
            this.visitor.plannedVisitID = row.id;
            // Ak je nastavene automaticke otvaranie zoznamu s naplanovanymi navstevami, tak on found zavriet
            this.dialogListPlanned = false;
            this.$emit('update:openPlanned', false);
            this.dialogDetail = true;
            return;
          }
        }
      }
    },
  },
  mounted() {
    this.dataLoad();
    this.$emit('update:openPlanned', false);
    this.$store.commit('flushPlannedVisits', false);
  },
  methods: {
    setDataToInput() {
      let newVisitor = { ...this.visitor };
      newVisitor.tranFrom = 'planedVisit';
      newVisitor.plannedVisitID = newVisitor.id;
      this.searchPlannedVisit.name ? (newVisitor.name = this.searchPlannedVisit.name) : '';
      this.searchPlannedVisit.surname ? (newVisitor.surname = this.searchPlannedVisit.surname) : '';
      this.searchPlannedVisit.documentno ? (newVisitor.documentno = this.searchPlannedVisit.documentno) : '';
      this.searchPlannedVisit.documenttype ? (newVisitor.documenttype = this.searchPlannedVisit.documenttype) : '';
      this.searchPlannedVisit.country ? (newVisitor.country = this.searchPlannedVisit.country) : '';
      this.searchPlannedVisit.expire ? (newVisitor.expire = this.searchPlannedVisit.expire) : '';
      this.$store.commit('currentDocument', newVisitor);
      this.dialogDetail = false;
      this.dialogListPlanned = false;
      this.$emit('update:openPlanned', false);
    },
    dataLoad() {
      axios
        .get('/api/v1/plannedvisits/approved')
        .then((response) => {
          for (const row of response.data) {
            row.visitorFullName = row.name + ' ' + row.surname;
            row.employeeFullName = row.employee.name + ' ' + row.employee.surname;
            row.approverFullName = row.approverName + ' ' + row.approverSurname;
          }
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getCountryName(visitorCountry: string) {
      let country: any;
      for (country of this.countries) {
        if (visitorCountry === country.A3) {
          return country.czFull;
        }
      }
      return '';
    },
    getDocumentType(documenttype: string) {
      let document: any;
      for (document of this.documentTypes) {
        if (documenttype === document.type) {
          return document.name;
        }
      }
      return '';
    },
    formatDate(date: string, format: string) {
      return this.$moment(date).format(format);
    },
  },
});
</script>
